import {
  getFlagIconClass,
  getNationalityLabel,
  normalizeCountryCode,
} from '@multirx/shared/types/nationalities.js';

export { getNationalityLabel, normalizeCountryCode };

function escapeHtml(s: string): string {
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
}

export interface NationalityFlagOptions {
  className?: string;
}

function codeFallbackHtml(code: string, label: string, extraClass: string): string {
  const display = escapeHtml(normalizeCountryCode(code) ?? '?');
  return `<span class="nationality-flag nationality-flag--code${extraClass}" title="${escapeHtml(label)}" aria-label="${escapeHtml(label)}" role="img">${display}</span>`;
}

/**
 * Drapeau via flag-icons (assets locaux, pas de CDN) + tooltip nom du pays.
 */
export function createNationalityFlag(
  code: string,
  options?: NationalityFlagOptions
): HTMLSpanElement {
  const label = getNationalityLabel(code);
  const flagClass = getFlagIconClass(code);
  const extra = options?.className ?? '';

  if (!flagClass) {
    const wrap = document.createElement('span');
    wrap.innerHTML = codeFallbackHtml(code, label, extra ? ` ${extra}` : '');
    return wrap.firstElementChild as HTMLSpanElement;
  }

  const span = document.createElement('span');
  span.className = ['nationality-flag', ...flagClass.split(' '), extra].filter(Boolean).join(' ');
  span.title = label;
  span.setAttribute('aria-label', label);
  span.setAttribute('role', 'img');
  return span;
}

export function nationalityFlagMarkup(code: string, options?: NationalityFlagOptions): string {
  const label = escapeHtml(getNationalityLabel(code));
  const flagClass = getFlagIconClass(code);
  const extra = options?.className ? ` ${escapeHtml(options.className)}` : '';

  if (!flagClass) {
    return codeFallbackHtml(code, label, extra);
  }

  const classes = escapeHtml(flagClass.split(' ').join(' '));
  return `<span class="nationality-flag ${classes}${extra}" title="${label}" aria-label="${label}" role="img"></span>`;
}

export function appendNationalityFlag(parent: HTMLElement, code: string): void {
  parent.appendChild(document.createTextNode(' '));
  parent.appendChild(createNationalityFlag(code));
}
